"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var status_action_keys_1 = require("./status-action-keys");

exports.infoMessageHideAction = function () {
  return {
    type: status_action_keys_1.StatusActionKeys.STATUS_INFO_MESSAGE_HIDE
  };
};